<template>
    <nav class="navbar navbar-expand-lg navbar-light" id="mainNav">
    <div class="container px-4 px-lg-5">
        <a class="navbar-brand" href="index.html">SharonRose</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavId" aria-controls="collapsibleNavId"
        aria-expanded="false" aria-label="Toggle navigation">
            <i class="fas fa-bars"></i>
        </button>
        <div class="collapse navbar-collapse" id="collapsibleNavId">
            <ul class="navbar-nav ms-auto py-4 py-lg-0">
                <li class="nav-item"><a class="nav-link px-lg-3 py-3 py-lg-4" href="index.html">Home</a></li>
                
                <li class="nav-item"><router-link to="/register" class="nav-link px-lg-3 py-3 py-lg-4" >Register Now</router-link></li>
            </ul>
        </div>
    </div>
 </nav>
    <div class="container" style="margin-top:150px">
       <div class="card">
      <div class="card-body">
        <div class="card-text">
          <div class="text-center add-text mb-4">Login</div>   
        </div>
        <div class="row justify-content-center mt-2">
          <div class="col-md-8">
            <form @submit.prevent="onSubmit">
              <div class="row justify-content-center">
                <div class="col-md-8 mb-4">
                    <input type="text" class="form-control" placeholder="Email" v-model="email">
                </div>
                <div class="col-md-8 mb-4 ">
                    <input type="password" class="form-control" placeholder="Password" v-model="pass">
                </div>
                <div class="col-md-8 mb-4">
                      <button class="btn btn-secondary btn-register">Login</button>
                  </div>
              </div>
              <!--  -->
            
              <!--  -->
            </form>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import Axios from 'axios'
// import url from '../url'
export default {

    data(){
        return{
          email:'',
          pass:''
        }
    },
    methods:{
      onSubmit:function(){
          let {email, pass} = this;
          let loginDetails = {email, pass}
          const URL = "https://stormy-ravine-66505.herokuapp.com/api/auth/login"
          Axios.post(URL, loginDetails).then(
            res=>{
              if(res.status == 200){
                localStorage.setItem('potal_data', JSON.stringify(res.data.response))
                this.$swal.fire({
                   icon: 'success',
                   title: 'Good',
                  text: res.data.message,
                  preConfirm:()=>{
                    this.$router.push('/profile')
                  }
                })
                console.log(res)
              }
              }
            ).catch(err =>{
              console.log(err)
              if (err.response.status == 400){
                console.log(err)
                this.$swal.fire({
                   icon: 'error',
                   title: 'Oops...',
                  text: err.response.data.message,
                })
              }else {
                this.$swal.fire({
                   icon: 'error',
                   title: 'Oops...',
                  text: err.message,
                })
              }
            
            })
        
      }
    }
}
</script>

<style lang="css" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500&family=Raleway&family=Roboto:wght@500&display=swap');
.form-control{
  box-shadow:none;
  border-radius: 0px;
  padding: 10px 15px;
  font-family: 'Poppins', sans-serif;

}
.form-control:focus{
  border: 1px solid #5a5a5a;

}
.add-text{
  font-size: 23px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
}
#mainNav {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1030;
    border-bottom: 1px solid #5a5a5a;
    background-color: rgb(121, 121, 121) !important;
    font-family: "Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  #mainNav .navbar-brand {
    font-weight: 800;
  }
  #mainNav .navbar-toggler {
    font-size: 0.75rem;
    font-weight: 800;
    padding: 0.75rem;
    text-transform: uppercase;
  }
  #mainNav .navbar-nav > li.nav-item > a.nav-link {
    font-size: 0.75rem;
    font-weight: 800;
    letter-spacing: 0.0625em;
    text-transform: uppercase;
  }
  @media (min-width: 992px) {
    #mainNav {
      border-bottom: 1px solid transparent;
      background: transparent;
    }
    #mainNav .navbar-brand {
      color: #fff;
    }
    #mainNav .navbar-brand:focus, #mainNav .navbar-brand:hover {
      color: rgba(255, 255, 255, 0.8);
    }
    #mainNav .navbar-nav > li.nav-item > a.nav-link {
      color: #fff;
    }
    #mainNav .navbar-nav > li.nav-item > a.nav-link:focus, #mainNav .navbar-nav > li.nav-item > a.nav-link:hover {
      color: rgba(255, 255, 255, 0.8);
    }
  }
  @media (min-width: 992px) {
    #mainNav {
      transition: background-color 0.2s;
      /* Force Hardware Acceleration in WebKit */
      transform: translate3d(0, 0, 0);
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
    }
    #mainNav.is-fixed {
      /* when the user scrolls down, we hide the header right above the viewport */
      position: fixed;
      top: -83px;
      transition: transform 0.2s;
      border-bottom: 1px solid white;
      background-color: rgba(255, 255, 255, 0.9);
    }
    #mainNav.is-fixed .navbar-brand {
      color: #212529;
    }
    #mainNav.is-fixed .navbar-brand:focus, #mainNav.is-fixed .navbar-brand:hover {
      color: #0085A1;
    }
    #mainNav.is-fixed .navbar-nav > li.nav-item > a {
      color: #212529;
    }
    #mainNav.is-fixed .navbar-nav > li.nav-item > a:focus, #mainNav.is-fixed .navbar-nav > li.nav-item > a:hover {
      color: #0085A1;
    }
    #mainNav.is-visible {
      /* if the user changes the scrolling direction, we show the header */
      transform: translate3d(0, 100%, 0);
    }
  }
  .btn-register{
     border: none !important;
     /* box-shadow: none; */
     outline: none;
     padding: 10px 50px;
     border-radius: 0%;
     font-family: 'Poppins';
     font-size: 15px;
     font-weight: 600;
  }
</style>